const MIX_OFFICE = "https://assets.mixkit.co/videos/preview/mixkit-working-overtime-in-a-futuristic-office-43093-large.mp4";
const MIX_LAPTOP = "https://assets.mixkit.co/videos/preview/mixkit-hands-of-a-man-working-on-a-laptop-42999-large.mp4";
const MIX_ALLEY = "https://assets.mixkit.co/videos/preview/mixkit-cinematic-scene-of-a-man-walking-in-a-dark-alley-41562-large.mp4";

const IMG_WORKSPACE = "https://images.unsplash.com/photo-1727451139462-cd34008cd50b?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200";
const IMG_TIMELINE = "https://images.unsplash.com/photo-1574717025058-2f8737d2e2b7?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200";
const IMG_CREW = "https://images.pexels.com/photos/8088384/pexels-photo-8088384.jpeg?auto=compress&cs=tinysrgb&w=1200";
const IMG_FILMMAKER = "https://images.pexels.com/photos/37681840/pexels-photo-37681840.jpeg?auto=compress&cs=tinysrgb&w=1200";
const IMG_NEON = "https://images.pexels.com/photos/4125601/pexels-photo-4125601.jpeg?auto=compress&cs=tinysrgb&w=1200";

export const shortFormProjects = [
  {
    slug: "hormozi-style-edit",
    title: "Alex Hormozi Style Edit",
    category: "Talking Head",
    duration: "0:22",
    views: "38K",
    thumb: "/thumbs/talking-head.jpg",
    video: "/videos/talking-head.mp4",
    description: "High-retention talking head edit with kinetic captions, pattern interrupts and punch-in zooms timed to the beat of the script.",
  },
  {
    slug: "restaurant-client-reel",
    title: "Restaurant Client Reel",
    category: "Brand Promo",
    duration: "0:30",
    views: "21K",
    thumb: "/thumbs/restaurant.jpg",
    video: "/videos/restaurant.mp4",
    description: "Mouth-watering cinematic reel for Al Baghdadi restaurant — speed ramps, rich color grade and sound design that sells the experience.",
  },
  {
    slug: "kinetic-captions-edit",
    title: "Kinetic Captions Edit",
    category: "Talking Head",
    duration: "0:45",
    views: "18K",
    thumb: "/thumbs/captions-1.jpg",
    thumbPos: "top",
    video: "/videos/captions-1.mp4",
    description: "Bold kinetic typography synced to every word — oversized captions, punch-ins and pacing built to hold attention from the first second.",
  },
  {
    slug: "bold-typography-reel",
    title: "Bold Typography Reel",
    category: "Creator Content",
    duration: "0:38",
    views: "26K",
    thumb: "/thumbs/captions-2.jpg",
    video: "/videos/captions-2.mp4",
    description: "High-contrast caption style edit — massive display type, color-blocked frames and word-by-word emphasis that makes the message unmissable.",
  },
  {
    slug: "beauty-ugc-ad",
    title: "Beauty UGC Ad",
    category: "UGC",
    duration: "0:13",
    views: "12K",
    thumb: "/thumbs/new-1.jpg",
    video: "/videos/new-1.mp4",
    description: "Aesthetic UGC product ad — dreamy product styling, water-drop macro shots and a clean beauty-brand feel that converts browsers into buyers.",
  },
  {
    slug: "luxury-product-ugc",
    title: "Luxury Product UGC",
    category: "UGC",
    duration: "0:02",
    views: "9K",
    thumb: "/thumbs/new-4.jpg",
    video: "/videos/new-4.mp4",
    description: "Macro luxury product loop for a beauty brand — glossy textures, mirror reflections and a premium feel in just seconds.",
  },
  {
    slug: "food-blogging-reel",
    title: "Food Blogging Reel",
    category: "Food / Restaurant",
    duration: "0:09",
    views: "15K",
    thumb: "/thumbs/new-2.jpg",
    video: "/videos/new-2.mp4",
    description: "Atmospheric food blogging reel — moody interiors, ambient detail shots and smooth transitions that make viewers want to visit tonight.",
  },
  {
    slug: "brand-logo-animation",
    title: "Brand Logo Animation",
    category: "Motion Graphics",
    duration: "0:08",
    views: "6K",
    thumb: "/thumbs/new-3.jpg",
    video: "/videos/new-3.mp4",
    description: "Elegant logo reveal animation with golden glow — the signature Sheen Creates intro used across reels and brand videos.",
  },
  {
    slug: "product-photography",
    title: "Product Photography",
    category: "Photography",
    duration: "Photo",
    views: "4K",
    thumb: "/brand-img.webp",
    video: null,
    description: "Styled product photography for beauty brands — soft florals, glossy surfaces and scroll-stopping composition for feeds and ads.",
  },
  {
    slug: "behind-the-edit",
    title: "Behind The Edit",
    category: "Process / BTS",
    duration: "0:17",
    views: "8K",
    thumb: "/thumbs/new-5.jpg",
    video: "/videos/new-5.mp4",
    description: "A look inside the editing process — timeline, cuts, captions and audio layering that turn a raw talking-head clip into a finished reel.",
  },
  {
    slug: "snack-brand-ugc-ad",
    title: "Snack Brand UGC Ad",
    category: "UGC / Food",
    duration: "0:11",
    views: "14K",
    thumb: "/thumbs/new-6.jpg",
    video: "/videos/new-6.mp4",
    description: "Punchy UGC ad for a snack brand — bold text pops, fast cuts and appetite-appeal framing made for feeds and paid social.",
  },
  {
    slug: "podcast-clip-edit",
    title: "Podcast Clip Edit",
    category: "Podcast Clip",
    duration: "0:23",
    views: "22K",
    thumb: "/thumbs/new-7.jpg",
    video: "/videos/new-7.mp4",
    description: "Podcast moment turned into a scroll-stopping clip — word-by-word captions, tight framing and pacing that carries the story beat.",
  },
  {
    slug: "creator-captions-edit",
    title: "Creator Captions Edit",
    category: "Talking Head",
    duration: "0:30",
    views: "19K",
    thumb: "/thumbs/new-8.jpg",
    video: "/videos/new-8.mp4",
    description: "Clean talking-head edit for an education creator — bold serif captions, subtle zooms and emphasis timing that keeps viewers watching.",
  },
];

export const longFormProjects = [
  {
    slug: "podcast-edit",
    title: "Podcast Edit",
    type: "Podcast / Interview",
    duration: "42:18",
    views: "84K views",
    thumb: IMG_CREW,
    video: "/videos/talking-head.mp4",
    client: "Business Podcast",
    role: "Lead Editor",
    tools: ["Premiere Pro", "After Effects", "Audition"],
    deliverables: ["Full-length episode edit", "Multi-cam sync & switching", "Audio cleanup & mastering", "12 short-form cutdowns"],
    results: [
      { value: "+64%", label: "Average view duration" },
      { value: "84K", label: "Episode views" },
      { value: "12", label: "Clips cut" },
    ],
    description: "A two-guest business podcast transformed from 3 hours of raw multi-cam footage into a tight, story-driven episode. Clean multicam switching, audio mastering, and a cold open that hooks viewers in the first 20 seconds.",
  },
  {
    slug: "documentary-edit",
    title: "Documentary Edit",
    type: "Mini Documentary",
    duration: "18:47",
    views: "62K views",
    thumb: IMG_NEON,
    video: "/videos/raw-edited.mp4",
    client: "Independent Creator",
    role: "Editor & Colorist",
    tools: ["Premiere Pro", "DaVinci Resolve"],
    deliverables: ["Narrative structure & story edit", "Cinematic color grade", "Sound design & score mixing", "Festival-ready export"],
    results: [
      { value: "71%", label: "Retention at 10 min" },
      { value: "62K", label: "Organic views" },
      { value: "4.8%", label: "CTR improvement" },
    ],
    description: "A character-driven mini documentary built from hours of footage. Structured around a three-act arc with a cinematic grade and a sound design pass that carries the emotional beats.",
  },
  {
    slug: "educational-youtube-video",
    title: "Educational YouTube Video",
    type: "Education",
    duration: "12:34",
    views: "78K views",
    thumb: IMG_TIMELINE,
    video: MIX_LAPTOP,
    client: "Education Channel",
    role: "Editor & Motion Designer",
    tools: ["Premiere Pro", "After Effects"],
    deliverables: ["Full episode edit", "Animated explainer graphics", "Chapter structure & pacing pass", "Thumbnail concept support"],
    results: [
      { value: "78K", label: "Views in 90 days" },
      { value: "+41%", label: "Subscriber growth" },
      { value: "58%", label: "Avg. percentage viewed" },
    ],
    description: "Dense educational material made genuinely watchable — animated diagrams, visual metaphors and ruthless pacing that keeps retention flat across a 12-minute runtime.",
  },
  {
    slug: "case-study-video",
    title: "Case Study Video",
    type: "Brand / SaaS",
    duration: "4:52",
    views: "28K views",
    thumb: IMG_WORKSPACE,
    video: MIX_OFFICE,
    client: "B2B SaaS Startup",
    role: "Editor",
    tools: ["Premiere Pro", "After Effects"],
    deliverables: ["Interview-driven story edit", "Product UI motion showcases", "Data visualization animations", "Sales-page & ad cutdowns"],
    results: [
      { value: "3.2x", label: "Demo bookings from page" },
      { value: "28K", label: "Cross-platform views" },
      { value: "6", label: "Ad variants delivered" },
    ],
    description: "A customer success story turned into the startup's highest-converting sales asset — interview narrative interwoven with animated product walkthroughs and hard results on screen.",
  },
  {
    slug: "vlog-edit",
    title: "Vlog Edit",
    type: "Lifestyle / Vlog",
    duration: "16:05",
    views: "69K views",
    thumb: IMG_FILMMAKER,
    video: MIX_ALLEY,
    client: "Travel Creator",
    role: "Editor",
    tools: ["Premiere Pro", "DaVinci Resolve"],
    deliverables: ["Story-first vlog assembly", "Music supervision & sync", "Cinematic travel grade", "Cold open & hook design"],
    results: [
      { value: "69K", label: "Views" },
      { value: "52%", label: "Avg. percentage viewed" },
      { value: "+28%", label: "Returning viewers" },
    ],
    description: "A travel vlog cut with a documentary sensibility — real story arcs, breathing room where it matters, and a grade that makes every location feel like a film still.",
  },
  {
    slug: "business-breakdown-video",
    title: "Business Breakdown Video",
    type: "Analysis / Finance",
    duration: "21:40",
    views: "95K views",
    thumb: IMG_TIMELINE,
    video: MIX_OFFICE,
    client: "Finance Channel",
    role: "Lead Editor",
    tools: ["Premiere Pro", "After Effects"],
    deliverables: ["Narrative edit & structure", "Animated charts & data scenes", "Archival footage research", "Retention editing pass"],
    results: [
      { value: "95K", label: "Views" },
      { value: "61%", label: "Retention at 15 min" },
      { value: "#3", label: "Trending in Finance" },
    ],
    description: "A 21-minute deep dive into a company's collapse — animated financials, archival footage and a thriller-like structure that made balance sheets feel like a crime story.",
  },
];

export const getProject = (slug) =>
  longFormProjects.find((p) => p.slug === slug) ||
  shortFormProjects.find((p) => p.slug === slug);
